import styled, { css } from 'styled-components';
import rem from 'polished/lib/helpers/rem';
import Typography from '../../base/Typography';

export const CredentialContainer = styled.div`
  ${({ theme }) => {
    const smallUp = theme.useMediaQuery(theme.breakpoints.up('small'));
    const mediumUp = theme.useMediaQuery(theme.breakpoints.up('medium'));
    let margin = '1rem 0';
    if (mediumUp) {
      margin = '1rem 1.25rem';
    } else if (smallUp) {
      margin = '1rem 1.25rem 0';
    }
    return css`
      margin: ${margin};
    `;
  }}
`;

export const CredentialHeadline = styled(Typography)`
  ${({ theme }) => css`
    margin-bottom: ${rem(16)};
    font-size: ${rem(64)};
    line-height: ${rem(50)};
    ::before {
      content: '';
      margin-right: ${rem(16)};
      display: inline-block;
      width: ${rem(3)};
      height: ${rem(46)};
      background-color: ${theme.colors.cta.yellow};
    }
    overflow: hidden;
    white-space: nowrap;
  `}
`;

export const CredentialFooter = styled.footer`
  display: none;
`;
